export default __webpack_public_path__ + "static/media/SAV_front.f8f06d1a.png";